// @ts-expect-error FIXME: REPAIR UPGRADE TO NEWER VERSION
import { useCycle } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGlobalStoreShallow } from 'src/store/globalStore';

import { menuWrapperVariants, mobileMenuVariants } from './variants';

import ProfileMobile from '@components/_global/Header/Profile/ProfileMobile/ProfileMobile';
import { BurgerMenu } from '@components/atoms/BurgerMenu/BurgerMenu';
import { HeaderLogos } from '@components/molecules/HeaderLogos/HeaderLogos';
import {
    HeaderWrapper,
    MobileCurrentSubsidiary,
    MobileLogoWrapper,
} from '@components/organisms/Header/Header.styled';
import { Notifications } from '@components/organisms/Notifications/Notifications';

import { UnreadNotificationCountDocument } from '@graphql/generated/graphql';

import { useQuery, useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

import {
    BurgerWrapper,
    GuestMode,
    GuestModeText,
    HeaderBackground,
    IconButton,
    MenuIcon,
    MobileNavigation,
    MobileWrapper,
    NotificationsDot,
    PoppingMenu,
} from './MobileMenu.styled';

interface MobileMenuProps {
    className?: string;
    currentSubsidiary?: string;
}

export const MobileMenu = ({
    className,
    currentSubsidiary,
}: MobileMenuProps) => {
    const { t } = useTranslation();
    const divWrapperRef = useRef<HTMLDivElement>(null);

    const isLongSubsidiaryName = (currentSubsidiary?.length ?? 0) > 50;
    const shortenSubsidiaryName = `${currentSubsidiary?.slice(0, 50)}... `;
    const [isMenuOpen, toggleIsMenuOpen] = useCycle(false, true);
    const [wrapperWidth, setWrapperWidth] = useState(50);
    const [isNotificationsOpen, setIsNotificationsOpen] = useState(false);
    const isGuest = useReactiveVar(authVar).isGuest;

    const { setBlockScroll } = useGlobalStoreShallow(['setBlockScroll']);

    const { data: notificationCount } = useQuery(
        UnreadNotificationCountDocument,
        { notifyOnNetworkStatusChange: true, skip: isGuest },
    );

    useEffect(() => {
        setBlockScroll(isMenuOpen);

        return () => {
            setBlockScroll(false);
        };
    }, [isMenuOpen]);

    useEffect(() => {
        if (divWrapperRef.current) {
            setWrapperWidth(
                divWrapperRef.current.getBoundingClientRect().width,
            );
        }
    }, [divWrapperRef]);

    return (
        <HeaderWrapper className={className}>
            <MobileWrapper
                animate={isMenuOpen ? 'open' : 'closed'}
                initial={false}
            >
                <BurgerWrapper width={wrapperWidth}>
                    <BurgerMenu onClick={toggleIsMenuOpen} />
                </BurgerWrapper>

                <MobileLogoWrapper>
                    <HeaderLogos />
                    <MobileCurrentSubsidiary>
                        {isLongSubsidiaryName
                            ? shortenSubsidiaryName
                            : currentSubsidiary}
                    </MobileCurrentSubsidiary>
                </MobileLogoWrapper>

                <div ref={divWrapperRef}>
                    {isGuest ? (
                        <GuestMode>
                            <GuestModeText>{t('GUEST')}</GuestModeText>
                        </GuestMode>
                    ) : (
                        <>
                            <IconButton
                                isOpen={isNotificationsOpen}
                                onClick={() => setIsNotificationsOpen(true)}
                            >
                                <MenuIcon icon={'SvgNotification'} size={24} />
                                {!!notificationCount?.amount && (
                                    <NotificationsDot />
                                )}
                            </IconButton>
                            <Notifications
                                isOpen={isNotificationsOpen}
                                onClose={() => setIsNotificationsOpen(false)}
                            />
                        </>
                    )}
                </div>

                <PoppingMenu variants={menuWrapperVariants}>
                    <HeaderBackground />
                    <MobileNavigation variants={mobileMenuVariants}>
                        <ProfileMobile />
                    </MobileNavigation>
                </PoppingMenu>
            </MobileWrapper>
        </HeaderWrapper>
    );
};
